import FormulaireConnexion from "@/components/FormulaireConnexion/FormulaireConnexionComponent";
import SocialLogin from "@/components/SocialLogin/SocialLoginComponent";
import styles from "./connexion.module.css";
import { CircleCheck } from "lucide-react";
import { ConnexionProps } from "@/types/ConnexionType";
import { SideImageCard } from "../atoms";

const iconMap = {
  CircleCheck: CircleCheck,
};

export default function ConnexionComponent({
  title,
  description,
  advantages = [],
  image,
}: ConnexionProps) {
  return (
    <div className="w-full mx-auto container mt-4 max-w-4xl">
      <SideImageCard imgSrc={image}>
        <h1 className={`${styles.title} text-md`}>{title}</h1>
        <p className={styles.description}>{description}</p>

        {advantages.length > 0 && (
          <ul className={styles.advantages}>
            {advantages.map((advantage, index) => {
              const IconComponent =
                iconMap[advantage.icon as keyof typeof iconMap] || CircleCheck;
              return (
                <li key={index} className={styles.advantageItem}>
                  <IconComponent className={styles.icon} />
                  <span>{advantage.text}</span>
                </li>
              );
            })}
          </ul>
        )}

        <FormulaireConnexion />
        <SocialLogin />
      </SideImageCard>
    </div>
  );
}
